import { isOpenDiscountModal } from "@/atoms/item/is-open-discount-modal";
import { ButtonColor } from "@/common/enum/button-color";
import { Button, Modal } from "flowbite-react";
import React from "react";
import { useSetRecoilState } from "recoil";
import { GrayExclamationCircleIcon } from "../icon/GrayExclamationCircleIcon";
import { Body16Regular } from "../typography/Body16Regular";

interface Props {}

export const DiscountModal: React.FC<Props> = () => {
  const setIsOpenModal = useSetRecoilState<boolean>(isOpenDiscountModal);

  const closeModal = () => {
    setIsOpenModal(false);
  };

  const handleSubmit = () => {
    closeModal();
  };

  return (
    <Modal size="md" show={true} onClose={closeModal}>
      <Modal.Header className="pt-[10px] px-[10px] h-[36px] border-none"></Modal.Header>
      <Modal.Body className="p-0">
        <div className="flex flex-col items-center box-border py-[20px] gap-[20px]">
          <div className="w-[42px] h-[42px] flex items-center justify-center">
            <GrayExclamationCircleIcon size={35} />
          </div>
          <div className="flex flex-col items-center">
            <Body16Regular className="text-semantic-text-secondary">
              고객에게 노출된 상품의 판매가는 조정이 불가합니다.
            </Body16Regular>
            <Body16Regular className="text-semantic-text-secondary">
              할인가를 조정해주세요.
            </Body16Regular>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="pt-0 border-none">
        <div className="flex items-center justify-center w-full">
          <Button size="sm" color={ButtonColor.PRIMARY} onClick={handleSubmit}>
            확인
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
